import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Container,
  Row,
} from "reactstrap";
// core components
import ProductEmoneyTable from "components/Tables/ProductEmoney.js";
import ProductEmoneyModal from "components/Modals/ProductEmoney.js";
import Header from "components/Headers/EmoneyHeader.js";
import ProductDataService from "../../services/ProductDataService";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultModal: false,
      products: [],
      perPage: 10,
      currentPage: 1,
      currentProduct: {},
    };
    this.productDataService = new ProductDataService();
  }

  toggleModal = (state, formType, product) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      currentProduct: product,
    });
  };
  
  toggleNavs = (e, state, index) => {
    e.preventDefault();
    this.setState({
      [state]: index,
      products: [],
      currentProduct: {},
      keyword: '',
      perPage: 10,
      currentPage: 1,
    }, () => {
      this.fetchData(this.state.keyword);
    });
  };

  componentDidMount() {
    this.fetchData()
  }
  
  handleSearch = (e) => {
    const keyword = e.target.value;
    this.setState({ 
      currentPage: keyword !== undefined && keyword !== '' ? 1 : this.state.currentPage,
      keyword: keyword,
    }, () => {
      this.fetchData(keyword);
    });
  }
  
  fetchData(keyword) {
    const { currentPage, perPage } = this.state;
      this.productDataService
        .getList(keyword, -1, currentPage, perPage, 0, true)
        .then(res => this.setState(res));
  }

  handlePageClick = (e) => {
    const selectedPage = e;

    this.setState({
        currentPage: selectedPage,
    }, () => {
      this.fetchData(this.state.keyword)
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message})
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const MAX_PAGES_DISPLAYED = 10;
    const { currentPage, totalPages } = this.state;

    const startPage = Math.max(currentPage - Math.floor(MAX_PAGES_DISPLAYED / 2), 1);
    const endPage = Math.min(startPage + MAX_PAGES_DISPLAYED - 1, totalPages);

    const minPage = 1;
    const maxPage = totalPages;

    const pageNumbersToDisplay = [];

    if (minPage < startPage) {
      pageNumbersToDisplay.push(minPage);
    }

    if (startPage > minPage + 1) {
      pageNumbersToDisplay.push('...');
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbersToDisplay.push(i);
    }

    if (endPage < maxPage - 1) {
      pageNumbersToDisplay.push('...');
    }

    if (maxPage > endPage && maxPage > 1) {
      pageNumbersToDisplay.push(maxPage);
    }

    const renderPageNumbers = (
      <div>
        <ul className="pagination">
          {pageNumbersToDisplay.map(number => (
            <PaginationItem key={number} className={currentPage === number ? "active" : ""}>
              {number === '...' ? (
                <PaginationLink disabled>{number}</PaginationLink>
              ) : (
                <PaginationLink onClick={() => this.handlePageClick(number)}>
                  {number}
                </PaginationLink>
              )}
            </PaginationItem>
          ))}
        </ul>
      </div>
    )
    
    return (
      <>
        <Header/>
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Daftar E-Money</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        onClick={() => this.toggleModal("formModal", "add")}
                        size="sm"
                      >
                        Tambah baru
                      </Button>
                      <ProductEmoneyModal
                        toggleModal={() => this.toggleModal("formModal")}
                        formModal={this.state.formModal}
                        formType={this.state.formType}
                        currentProduct={this.state.currentProduct}
                        setSuccessMessage={this.setSuccessMessage}
                        fetchData={this.fetchData.bind(this)}
                      />
                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col xs="4" className="mt-3 align-items-right">
                      <FormGroup>
                        <InputGroup className="input-group-alternative mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-zoom-split-in" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            className="form-control-alternative"
                            placeholder="Search"
                            onChange={(e) => this.handleSearch(e)}
                            type="text"
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <ProductEmoneyTable 
                  products={this.state.products} 
                  toggleModal={this.toggleModal}
                  formModal={this.state.formModal}
                  formType={this.state.formType}
                  setSuccessMessage={this.setSuccessMessage}
                  fetchData={this.fetchData.bind(this)}
                />
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handlePreviousPageClick()}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>
                      {renderPageNumbers}
                      <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handleNextPageClick()}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default List;
